import { Flex } from "antd";
import React from "react";

/**
 * Global form required mark renderer.
 * Displays "(Required)" in muted grey text next to the label instead of a red asterisk.
 */
export const renderRequiredMark = (label, info) => (
  <Flex gap={3} align="center">
    {label}
    {info.required && (
      <span className="text-gray-400 font-normal text-xs">(Required)</span>
    )}
  </Flex>
);
